import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export function createUserPreRegistration(data, config = {}) {
  return httpUtils.post(`${env.API_VERSION}/user-pre-registration`, data, config);
}

export function updateUserPreRegistration(id, data, config = {}) {
  return httpUtils.put(`${env.API_VERSION}/user-pre-registration/${id}`, data, config);
}
